module.exports = __webpack_public_path__ + "img/reset-password.9cd3690f.png";